<div id="wrapper">
  <a id="prev" (click)="previous()">&#10094;</a>
  <div id="container">
    <div class="picture" *ngFor="let picture of pictures; let i = index" id="{{i}}" onLoad="setOpacity()">
      <img [src]="picture.src" alt="picture" [hidden]="!picture.loaded && loadingUrl" (load)="picture.loaded = true"
           (click)="pictureClick(picture)">
      <img *ngIf="loadingUrl" [src]="loadingUrl" alt="loading" [hidden]="picture.loaded">
    </div>
  </div>
  <a id="next" (click)="next()">&#10095;</a>

  <!-- The dots/circles -->
  <div class="dots">
    <span class="dot" *ngFor="let picture of pictures; let i = index" [class.active]="currentIndex === i"
          (click)="goTo(i)"></span>
  </div>
</div>
